import {inject, Injectable, signal} from '@angular/core'
import {HttpClient, HttpHeaders} from '@angular/common/http'
import {IExchangeResponse, IGitLabAuth, ISelf} from '../1-application/types'
import {Observable, of, switchMap, tap} from 'rxjs'
import {environment} from '../../environments/environment'
import {LOCAL_STORAGE} from '../0-general/providers'
import {ACCESS_TOKEN_NAME, GITLAB_TOKEN_NAME} from '../1-application/constants'

export const provideNoopAuthService = () => ({
  provide: AuthService,
  useValue: {
    accessToken: signal({}),
    gitLabToken: signal({}),
    exchange: () => of({}),
    getSelf: () => of({}),
    refresh: () => of({})
  }
})

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public accessToken = signal<Partial<IExchangeResponse>>({})
  public gitLabToken = signal<Partial<IGitLabAuth>>({})

  private http = inject(HttpClient)

  private storage = inject(LOCAL_STORAGE)

  /**
   * We need to replace this with a "bootstrap" function in the
   * application.
   */
  constructor() {
    this.boostrap().subscribe()
  }

  public boostrap(): Observable<any> {
    const accessToken = this.storage.getItem(ACCESS_TOKEN_NAME)
    if (accessToken) {
      this.accessToken.set(JSON.parse(accessToken))
    }

    const gitlabToken = this.storage.getItem(GITLAB_TOKEN_NAME)
    if (gitlabToken) {
      this.gitLabToken.set(JSON.parse(gitlabToken))
    }
    return of({})
  }

  public exchange(state: string, nonce: string): Observable<any> {
    return this.http.put<IExchangeResponse>(
      `${environment.apiUrl}/exchange`, {state, nonce})
      .pipe(
        tap(res => {
          res.expires = res.expires * 1000 + Date.now()
          this.storage.setItem(GITLAB_TOKEN_NAME, JSON.stringify(res.gitlab))
          this.gitLabToken.set(res.gitlab!)
          delete res.gitlab
          this.storage.setItem(ACCESS_TOKEN_NAME, JSON.stringify(res))
          this.accessToken.set(res)
        }),
        switchMap(() => this.getSelf())
      )
  }

  public getSelf(): Observable<any> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${this.accessToken().accessToken}`})
    return this.http.get<ISelf>(`${environment.apiUrl}/user/self`, {headers})
      .pipe()
  }

  public refresh(): void {
    const rt = this.accessToken().refreshToken
    this.http.get<IExchangeResponse>(`${environment.apiUrl}/refresh?rt=${rt}`)
      .subscribe(res => {
        res.expires = Date.now() + (res.expires * 1000)
        this.accessToken.set(res)
        this.storage.setItem(ACCESS_TOKEN_NAME, JSON.stringify(res))
      })
  }
}

